import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getSubscriptionByUserId } from "../utils/subscriptions";

export const fetchSubscription = createAsyncThunk(
  "subscription/fetchSubscription",
  async ({ classRoomId, userId }) => {
    try {
      const response = await getSubscriptionByUserId(classRoomId, userId);
      if (response?.subscription) {
        return { ...response.subscription, updatedAt: new Date() }; // Add updatedAt to the response
      } else {
        return { error: "No subscription found" }; // Return a default object if no subscription
      }
    } catch (error) {
      return { error: "No subscription found" }; // Handle any error case as no subscription
    }
  }
);

export const fetchSubscriptionByUserId = async (classRoomId, userId) => {
  try {
    const response = await getSubscriptionByUserId(classRoomId, userId);
    if (response?.subscription) {
      
      return { ...response.subscription, updatedAt: new Date() };
    } else {
      throw new Error("No subscription found");
    }
  } catch (error) {
    throw new Error("Error fetching subscription");
  }
};

const subscriptionSlice = createSlice({
  name: "subscription",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {
    clearSubscription(state) {
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSubscription.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchSubscription.fulfilled, (state, action) => {
        state.data = action.payload;
        state.loading = false;
      })
      .addCase(fetchSubscription.rejected, (state, action) => {
        state.error = action.error;
        state.loading = false;
      });
  },
});
export const { clearSubscription } = subscriptionSlice.actions;
export default subscriptionSlice.reducer;
